"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeItem = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var util_1 = require("@gooddata/util");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
exports.AttributeItem = function (_a) {
    var item = _a.item, iconClass = _a.iconClass, isSelected = _a.isSelected, onSelect = _a.onSelect, onDropDownItemMouseOver = _a.onDropDownItemMouseOver, onDropDownItemMouseOut = _a.onDropDownItemMouseOut, customGranularitySelection = _a.customGranularitySelection;
    var title = item.title, ref = item.ref;
    var isDisabled = customGranularitySelection && !customGranularitySelection.enable;
    var className = classnames_1.default("gd-list-item", "gd-list-item-shortened", {
        "is-selected": isSelected,
        "is-disabled": isDisabled,
    }, "gd-button-link", iconClass, "s-rf-attribute-" + util_1.stringUtils.simplifyText(title));
    var onMouseOver = function () {
        if (onDropDownItemMouseOver) {
            onDropDownItemMouseOver(ref);
        }
    };
    var onMouseOut = function () {
        if (onDropDownItemMouseOut) {
            onDropDownItemMouseOut();
        }
    };
    if (!isDisabled) {
        return (react_1.default.createElement("button", { className: className, onClick: function () { return onSelect(ref); }, onMouseOver: onMouseOver, onMouseOut: onMouseOut, title: title },
            react_1.default.createElement("span", null, title)));
    }
    return (react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { showDelay: 0, hideDelay: 0 },
        react_1.default.createElement(sdk_ui_kit_1.Button, { className: className, value: title, title: title, disabled: true }),
        react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-primary gd-rf-tooltip-bubble s-rf-disabled-attribute-bubble", alignPoints: [{ align: "cr cl" }, { align: "cl cr" }] }, customGranularitySelection.warningMessage)));
};
//# sourceMappingURL=AttributeItem.js.map